/** @jsxImportSource react */
import type { SVGProps } from 'react';
const ErrorOutline = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 24 24" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12 20a8 8 0 1 0 0-16 8 8 0 0 0 0 16m0 1.5a9.5 9.5 0 1 0 0-19 9.5 9.5 0 0 0 0 19"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12 13.5a.75.75 0 0 1-.75-.75v-5a.75.75 0 0 1 1.5 0v5a.75.75 0 0 1-.75.75"
      clipRule="evenodd"
    />
    <path fill="currentColor" d="M11 16a1 1 0 1 1 2 0 1 1 0 0 1-2 0" />
  </svg>
);
export default ErrorOutline;
